export enum Permissions {
  VIEW = 'VER',
  CREATE = 'CREAR',
  EDIT = 'EDITAR',
  DELETE = 'ELIMINAR',
  LOAD = 'CARGA',
  DOWNLOAD = 'DESCARGA',
  INDIVIDUAL_PERMISSIONS = 'HABILITAR/DESHABILITAR',
  ALL_FUERZAS_VENTAS = 'FUERZA DE VENTA (VER TODAS)',
  // VIEW_CONFIG_DAT = 'VER CONFIGURACIÓN DAT',
  // EDIT_CONFIG_DAT = 'EDITAR CONFIGURACIÓN DAT',


  VIEW_NAME = 'VER NOMBRE DAT',
  VIEW_CHANNEL = 'VER CANAL DAT',
  VIEW_FUERZA_VENTA = 'VER FUERZA DE VENTA DAT',

  EDIT_NAME = 'EDITAR NOMBRE DAT',
  EDIT_CHANNEL = 'EDITAR CANAL DAT',
  EDIT_FUERZA_VENTA = 'EDITAR FUERZA DE VENTA DAT',
}

export enum IndividualPermission {
  ID_AGENT = 'Id agente',
  NAME = 'Nombre',
  Status = 'Estado',
  Role = 'Rol',
}
